import { Controller } from "@hotwired/stimulus";

// The event-wide default has no enabled flag: there is nothing left to fall
// back to if the fallback itself is switched off. Only a track override
// carries one.
//
// On edit the server already knows the target and renders accordingly, but on
// the add form the target is chosen in the browser, so this follows the
// select. The field is disabled as well as hidden, since a hidden-but-enabled
// checkbox still submits.
export class ConfirmationMessageFormController extends Controller {
  static values = { defaultTarget: String };

  connect() {
    this.toggleEnabled();
  }

  toggleEnabled() {
    const select = this.element.querySelector('select[name*="[target]"]');
    const checkbox = this.element.querySelector('input[type="checkbox"][name*="[enabled]"]');
    if (!select || !checkbox) return;

    const field = checkbox.closest(".FormControl-check-group, .FormControl, .form-group") || checkbox.parentElement;
    const isDefault = select.value === this.defaultTargetValue;

    field.classList.toggle("d-none", isDefault);
    checkbox.disabled = isDefault;
  }
}
